import * as React from 'react';
export const ValidatorContext = React.createContext({
    validatorState: { invalidMessages: {}, refreshIds: {} },
    validatorDispatch: () => null,
});
export function useValidatorContext() {
    return React.useContext(ValidatorContext);
}
